var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.talentLoading,
          expression: "talentLoading",
        },
      ],
      staticStyle: { "min-height": "200px" },
    },
    [
      _vm.achData && _vm.achData.length && !_vm.talentLoading
        ? _c(
            "div",
            _vm._l(_vm.achData, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "person-item",
                  on: {
                    click: function ($event) {
                      return _vm.toDetail(item.id)
                    },
                  },
                },
                [
                  _c("div", { staticStyle: { "margin-left": "8px" } }, [
                    _c("div", { staticClass: "person-name" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    item.authors && item.authors.length
                      ? _c(
                          "div",
                          { staticClass: "item-left" },
                          [
                            _vm._v(" 作者： "),
                            _vm._l(
                              item.authors.length > 3
                                ? item.authors.splice(0, 3)
                                : item.authors,
                              function (auther, index) {
                                return _c(
                                  "span",
                                  {
                                    key: index,
                                    staticClass: "item-right",
                                    staticStyle: { "margin-right": "9px" },
                                  },
                                  [
                                    _c(
                                      "el-avatar",
                                      {
                                        attrs: {
                                          fit: "cover",
                                          size: 14,
                                          src: auther.avatarUrl,
                                        },
                                        on: { error: _vm.errorHandler },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: "https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticStyle: { "margin-left": "3px" } },
                                      [_vm._v(_vm._s(auther.scholarName))]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _c("div", { staticClass: "item-left" }, [
                          _vm._v("作者："),
                          _c(
                            "span",
                            {
                              staticClass: "item-right",
                              staticStyle: { "margin-right": "9px" },
                            },
                            [_vm._v("-")]
                          ),
                        ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v(" 项目类别："),
                      _c("span", { staticClass: "item-right" }, [
                        _vm._v(_vm._s(item.typeFirst || "-")),
                      ]),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _c("div", [_c("el-empty")], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }